export const PARAM_TRUE_VALUE = 'true';
export const PARAM_FALSE_VALUE = 'false';
export type ParamBoolean = typeof PARAM_FALSE_VALUE | typeof PARAM_TRUE_VALUE;
